var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 3.33366V0.666992L4.66602 4.00033L7.99935 7.33366V4.66699C10.206 4.66699 11.9993 6.46033 11.9993 8.66699C11.9993 10.8737 10.206 12.667 7.99935 12.667C5.79268 12.667 3.99935 10.8737 3.99935 8.66699H2.66602C2.66602 11.6137 5.05268 14.0003 7.99935 14.0003C10.946 14.0003 13.3327 11.6137 13.3327 8.66699C13.3327 5.72032 10.946 3.33366 7.99935 3.33366Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeft);
export default __webpack_public_path__ + "static/media/iconLeft.cf4904e3c2df6b806ffa62f1801e3fef.svg";
export { ForwardRef as ReactComponent };